module.exports = __webpack_public_path__ + "img/promotion-boost-pro.c1cb9d5b.svg";